import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar-instruction',
  templateUrl: './navbar-instruction.component.html',
  standalone: false,
  styleUrl: './navbar-instruction.component.scss',
})
export class NavbarInstructionComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: 'sequence' | 'flight',
    private dialog: MatDialog,
    private router: Router,
  ) {}

  onSearchClick(): void {
    this.dialog.closeAll();
    this.router.navigate(['search']);
  }
}
